import type { Manifest, Values } from '..';

import type { ConfigureBuilder, PostProcessFilesFn } from './configure-builder';
import { type ConfigureOpts, mkConfigureScriptWithOpts } from './docker-compose';
import { dockerCompose } from './docker-compose';

function mkConfigureScript(manifest: Manifest, values: Values, fn?: PostProcessFilesFn): string {
  manifest.deployment.contents ||= {};
  manifest.deployment.contents['docker-compose'] ||= manifest.deployment.contents['nerd-compose'];

  const baseBootstrap = `
# ---

export NERDCTL_VERSION=2.2.0
curl -sL https://github.com/containerd/nerdctl/releases/download/v\${NERDCTL_VERSION}/nerdctl-full-\${NERDCTL_VERSION}-linux-amd64.tar.gz \
  | tar Cxzv /usr/local

export SOCI_VERSION="0.11.1"
curl -sL https://github.com/awslabs/soci-snapshotter/releases/download/v\${SOCI_VERSION}/soci-snapshotter-\${SOCI_VERSION}-linux-amd64.tar.gz \
  | tar -C /usr/local/bin -xzv soci soci-snapshotter-grpc

wget -nv \
  "https://raw.githubusercontent.com/awslabs/soci-snapshotter/refs/heads/main/soci-snapshotter.service" \
  -O /usr/local/lib/systemd/system/soci-snapshotter.service

# lower log level
sed -i -e 's/debug/info/' /usr/local/lib/systemd/system/stargz-snapshotter.service

# install containerd config
mkdir -p /etc/containerd
cat <<EOF > /etc/containerd/config.toml
version = 2
[proxy_plugins]
  [proxy_plugins.soci]
    type = "snapshot"
    address = "/run/soci-snapshotter-grpc/soci-snapshotter-grpc.sock"
  [proxy_plugins.stargz]
    type = "snapshot"
    address = "/run/containerd-stargz-grpc/containerd-stargz-grpc.sock"
EOF

# start services
systemctl daemon-reload
systemctl enable --now soci-snapshotter containerd stargz-snapshotter

# ---
`;

  const opts: ConfigureOpts = {
    baseBootstrap,
    pullCmd: 'nerdctl compose pull --snapshotter soci --quiet',
    upCmd: 'nerdctl compose up --snapshotter soci --quiet-pull --detach',
    proxyServices: [
      '/usr/local/lib/systemd/system/containerd.service',
      '/usr/local/lib/systemd/system/soci-snapshotter.service',
      '/usr/local/lib/systemd/system/stargz-snapshotter.service',
    ],
  };

  return mkConfigureScriptWithOpts(manifest, values, opts, fn);
}

export const nerdCompose = {
  mkConfigureScript,
  prepareConfigureData: dockerCompose.prepareConfigureData,
} as ConfigureBuilder;

export default nerdCompose;
